

import __layout_0 from '/mnt/space/work/app/src/layouts/default.vue'
export const layouts = {
'404': () => import('/mnt/space/work/app/src/layouts/404.vue'),
'auth': () => import('/mnt/space/work/app/src/layouts/auth.vue'),
'default': __layout_0,
'register': () => import('/mnt/space/work/app/src/layouts/register.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
